import script from "./ReportingDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportingDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ReportingDashboard.vue?vue&type=style&index=0&id=7cb6e744&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb6e744"]])

export default __exports__